module.exports = __webpack_public_path__ + "images/e27ef264559897fa99ee528306d732aa.svg";